@if (menuMode) {
  <div id="apps-icon">
    <sh-icon button icon="apps" aria-label="Apps"></sh-icon>
    <sh-text size="body-2" color="primary" class="text-icon">Apps</sh-text>
  </div>
  <sh-popover
    target="apps-icon"
    position="bottom-left"
    class="helpful-link-wrapper"
  >
    <div class="helpful-link-body">
      <ng-component *ngTemplateOutlet="links"></ng-component>
    </div>
  </sh-popover>
} @else {
  <ng-component *ngTemplateOutlet="links"></ng-component>
}

<ng-template #links>
  <div class="title">
    @if (showTitle) {
      <sh-text title size="header-2" columns="12" color="primary">
        Useful Applications
      </sh-text>
    }
    @if (showInfoIcon) {
      <sh-icon
        icon="information"
        role="button"
        size="s"
        button
        id="info-icon"
        [matTooltip]="
          (configurationController.usefulAppConfiguration$ | async)?.infoText
        "
        [aria-label]="
          'tooltip that explains ' +
          (configurationController.usefulAppConfiguration$ | async)?.infoText
        "
        matTooltipClass="tooltip-style"
      >
        ></sh-icon
      >
    }
    <!-- Shui implementation -->
    <!-- <sh-icon icon="information" id="info-icon"></sh-icon>
    <sh-tooltip
      id="info-icon"
      label="Some linked applications might not work properly"
      placement="bottom"
      target="info-icon"
      variation="short"
    ></sh-tooltip> -->
  </div>

  @if (configurationController.isAppConfigurationLoading$ | async) {
    <sh-spinner style="margin: auto"></sh-spinner>
  } @else {
    <div
      class="layout"
      [ngStyle]="{ display: displayType, flexWrap: flexWrapType }"
    >
      @for (
        app of (configurationController.usefulAppConfiguration$ | async)
          ?.applications;
        track $index
      ) {
        @if ((screenLayoutService.desktopAny$ | async) || app.mobileEnabled) {
          <a
            [href]="
              updatePlaceHolder(app.link, (systemDetails$ | async) ?? undefined)
            "
            target="_blank"
            (click)="
              onUsefulApplicationClick(
                app.title,
                updatePlaceHolder(app.link, systemDetails)
              )
            "
          >
            <sh-tool
              [label]="app.title"
              [icon]="app.icon"
              [id]="'usefulApp-' + $index"
            ></sh-tool>
          </a>
        }
      }
    </div>
  }
</ng-template>
